import React from "react";
import Checkbox from "src/scenes/EmployeeList/components/Checkbox";
import { Td, ButtonLabel, TdContent, TdCenter } from "../style/Table.style";
import { QuoteImageCard, ArticleImageCard } from ".";
import { TableRowCell } from "src/components/TableRowCell";
import { htmlToCaption } from "src/components/RichTextEditor/htmlToCaption";

export const Rows = ({ quotes, onToggle, isSelected, manageQuotes }) => {
    const renderRow = (quote, index) => (
        <tr key={index} className={isSelected(quote.uuid) ? "selected" : ""}>
            <TdCenter paddingLeft="0" align="center">
                <label>
                    <Checkbox
                        readOnly
                        checked={isSelected(quote.uuid)}
                        value={quote.uuid}
                        onChange={() => onToggle(quote)}
                    />
                </label>
            </TdCenter>
            <TdCenter width="5rem">
                <QuoteImageCard
                    src={quote.quoteImage}
                    loading={!quote.quoteImage}
                />
            </TdCenter>
            <Td>
                <TableRowCell content={quote?.quoteText} clamp={2} padding="0" />
            </Td>
            <TdCenter>
                <ArticleImageCard
                    src={quote.articleImage}
                    loading={!quote.articleImage}
                />
            </TdCenter>
            <Td>
                <TdContent>{quote.articleTitle}</TdContent>
            </Td>
            <Td>
                <TableRowCell content={htmlToCaption(quote?.articleDescription)} clamp={4} padding="0" />
            </Td>
            <TdCenter>
                <ButtonLabel onClick={() => manageQuotes.createQuotes(quote)}>View/Edit</ButtonLabel>
            </TdCenter>
        </tr>
    );

    const renderEmpty = () => {
        const emptyRows = 10 - quotes.length;
        if (emptyRows < 1) return null;

        return Array.from({ length: emptyRows }, (_, i) => (
            <tr key={"empty_" + i}>
                {Array.from({ length: 7 }, (_, j) => (
                    <Td key={`empty_cell_${i}_${j}`} paddingLeft="0" align="center">
                        &nbsp;
                    </Td>
                ))}
            </tr>
        ));
    };

    return (
        <>
            {quotes.map(renderRow)}
            {renderEmpty()}
        </>
    );
};
